import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { stateNames } from "../../../../../../db/schema/orders.js";
import { get } from "../../../../../modules/get.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./infoAfterLogin.css";
//we do It in order to provide compatibility with merchants panel
const defaultToastOptions = {
    position: "top-left",
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    autoClose: 9000,
};
export default function InfoAfterLogin(props) {
    const { allowLoginToOrder } = props;
    const [childrenOrders, setChildrenOrders] = useState([]);
    useEffect(() => {
        get("/api/public/clients/orders/").then((res) => {
            if (res.status !== 200)
                return void toast.error("Nie udało się pobrać danych", defaultToastOptions);
            const { children } = res;
            setChildrenOrders(children);
        });
    }, []);
    return (React.createElement("div", { className: "login-container", onClick: () => props.onExit() },
        React.createElement("div", { className: "login-box options-box-container", onClick: (event) => event.stopPropagation() },
            "Zam\u00F3wienie na podany adres email ju\u017C istnieje!",
            React.createElement("br", null),
            allowLoginToOrder && (React.createElement(React.Fragment, null,
                "Wybierz zam\u00F3wienie kt\u00F3re chcesz otworzy\u0107:",
                childrenOrders.map((child, index) => (React.createElement(Button, { value: "open_old_order", text: "", key: index, version: "alternative", onClick: () => {
                        sessionStorage.setItem("name", child.name);
                        sessionStorage.setItem("email", child.email);
                        sessionStorage.setItem("phone", child.phone);
                        props.onOpenOldOrder();
                    } },
                    "Imi\u0119 i nazwisko: ",
                    child.name,
                    React.createElement("br", null),
                    "Telefon: ",
                    child.phone,
                    React.createElement("br", null),
                    "Status: ",
                    stateNames.get(child.state)))),
                "lub",
                React.createElement("br", null))),
            React.createElement(Button, { value: "creating_new_order", text: "", version: "alternative", onClick: props.onCreateNewOrder }, "Utw\u00F3rz nowe zam\u00F3wienie"))));
}
